import { Cancel01Icon } from '@hugeicons/react'

import { useNavigation } from '@/shared/hooks/useNavigation'
import { stepProgressPercent } from '@/shared/level-play/stepNavigation'
import { Button } from '@/shared/ui/Button'
import { confirmExitLevel } from '@/shared/ui/dialog'
import { LevelPlay } from '@/shared/ui/LevelPlay'
import { ProgressBar } from '@/shared/ui/ProgressBar'

import { DigitalProductJourneyLevelHeartsAndCountdown } from './HeartsAndCountdown'
import { useTrackLevelAnalytics } from '../../../analytics'
import { useLevelContext } from '../../context'

export const DigitalProductJourneyLevelPlayChallengeToolbar = ({ activity }) => {
  const { currentStepIndex, totalSteps, journey, level } = useLevelContext()
  const { navigateTo } = useNavigation()

  const { trackLevelLeave } = useTrackLevelAnalytics({ level })

  const handleBackToJourney = async () => {
    const isConfirmed = await confirmExitLevel()

    if (isConfirmed) {
      navigateTo(`/jornadas/${journey?.uid}`)
      trackLevelLeave()
    }
  }

  // `currentStepIndex` da jornada já é base zero, que é a convenção do motor —
  // não precisa de ponte. O guard de `totalSteps` ausente (que produzia `NaN`)
  // agora vive no próprio `stepProgressPercent`.
  const pct = stepProgressPercent({ currentStepIndex, totalSteps })

  return (
    <LevelPlay.Toolbar>
      <div className="w-[125px]">
        <Button
          variant="danger-ghost"
          icon
          onClick={handleBackToJourney}
          aria-label="Sair do nível"
          leadingIcon={<Cancel01Icon variant="solid" size={22} />}
        />
        {/* <DigitalProductJourneyLevelVouchers
              onUseVoucher={voucherId => handleCompleteChallenge({ voucherId })} />
          */}
      </div>
      <ProgressBar value={pct} variant="progress" size="lg" aria-label="Progresso do nível" />
      <div className="w-[125px] flex justify-end">
        <DigitalProductJourneyLevelHeartsAndCountdown activity={activity} />
      </div>
    </LevelPlay.Toolbar>
  )
}
